export default "__VITE_ASSET__690637ae__"